/**
 * Progress: the bar's thin track under the category switch (Figma 00, 22:20): how far through the category the
 * walk stands. With no position to show (the contract gives none) it draws nothing, never an empty track that
 * would say "none done".
 */
import { RADIUS, WALK, usePalette } from '../theme';

export type ProgressState =
  | { readonly kind: 'known'; readonly done: number; readonly total: number }
  | { readonly kind: 'unknown' };

/** `bar` is the thin track under the category switch; `tile` fills a card's width (the picker, Figma 21:10). */
export type ProgressLook = 'bar' | 'tile';

export function Progress({ state, label, look = 'bar' }: { state: ProgressState; label: string; look?: ProgressLook }) {
  const p = usePalette();
  switch (state.kind) {
    case 'unknown':
      return null;
    case 'known':
      return (
        <div
          role="progressbar"
          aria-label={label}
          aria-valuemin={0}
          aria-valuemax={state.total}
          aria-valuenow={state.done}
          style={{ width: look === 'tile' ? '100%' : WALK.trackWidth, height: WALK.trackHeight, borderRadius: RADIUS.xs, background: p.surfaceRaised, overflow: 'hidden', flexShrink: 0 }}
        >
          <div style={{ width: `${state.total === 0 ? 0 : (state.done / state.total) * 100}%`, height: '100%', borderRadius: RADIUS.xs, background: look === 'tile' && state.done === state.total ? p.categorical[2] : p.inkStrong }} />
        </div>
      );
  }
}
